import React from "react";
import { Card, CardActions, CardContent, Typography, Box } from "@mui/material";
import PropTypes from "prop-types";

function StyledCard({
  action,
  icon: IconComponent,
  title,
  description,
  dark = false,
  danger = false,
  ...props
}) {
  const textColor = dark ? "white" : "text.primary";
  const bgColor = dark ? "accent.dark" : "#f0f0f0";

  const getIconColor = () => {
    if (dark) {
      return "white";
    }

    if (danger) {
      return "error.light";
    }

    return "accent.dark";
  };

  const iconColor = getIconColor();

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        position: "relative",
        backgroundColor: bgColor,
        boxSizing: "border-box",
        border: dark ? undefined : "none",
        // overflow: "hidden",
        // ...props.sx,
      }}
      {...props}
    >
      {/* Background Icon */}
      {IconComponent && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            opacity: 0.5,
            zIndex: 0,
          }}
        >
          <IconComponent sx={{ fontSize: 32, color: iconColor }} />
        </Box>
      )}

      <CardContent sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="body1"
          component="div"
          gutterBottom={!!description}
          sx={{ color: textColor }}
          marginRight="32px"
          fontWeight="600"
        >
          {title}
        </Typography>
        {description && (
          <Typography
            variant="body2"
            color={dark ? "white" : "text.secondary"}
            marginTop={2}
          >
            {description}
          </Typography>
        )}
      </CardContent>

      {action && <CardActions sx={{ padding: 2 }}>{action}</CardActions>}
    </Card>
  );
}

StyledCard.propTypes = {
  action: PropTypes.node,
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  bgColor: PropTypes.string,
  dark: PropTypes.bool,
  danger: PropTypes.bool,
};

export default StyledCard;
